import dispatcher from "../dispatcher";
import rq from "../components/utility/rq.js";
import { stockInConstant } from "../constants/constants";

export function cratedStockIn(stockIn) {
    rq.postJson("/api/v1/stockIn", stockIn).then((data) => {
        stockIn.stockInId = data[0].lastId;
        dispatcher.dispatch({ type: stockInConstant.STOCKIN_CREATED, stockIn });
    }).catch((data) => {
        if (data.status === 400) {
            dispatcher.dispatch({ type: stockInConstant.STOCKIN_CREATION_FAILED, msg: JSON.parse(data.responseText) });
        } else {
            dispatcher.dispatch({ type: stockInConstant.STOCKIN_CREATION_FAILED, msg: ` StockIn  failed` });
        }
    });

}
export function cratedBackWardStockIn(stockIn) {
    rq.postJson("/api/v1/backward-stockIn", stockIn).then((data) => {
        stockIn.stockInId = data[0].lastId;
        dispatcher.dispatch({ type: stockInConstant.STOCKIN_CREATED, stockIn });
    }).catch((data) => {
        if (data.status === 400) {
            dispatcher.dispatch({ type: stockInConstant.STOCKIN_CREATION_FAILED, msg: JSON.parse(data.responseText) });
        } else {
            dispatcher.dispatch({ type: stockInConstant.STOCKIN_CREATION_FAILED, msg: ` StockIn  failed` });
        }
    });

}




// WEBPACK FOOTER //
// ./src/jsx/actions/stockin-action.jsx